import React, { useState, useEffect } from 'react';
import { RouteProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import WithLoading from '../../../hocs/WithLoading/WithLoading';
import { auth } from '../../../utils/auth';
import { useAuth } from '../../../contexts/AuthContext';

const SSORoute: React.FC<RouteProps> = (): JSX.Element | null => {
    const { session, loading } = useAuth();
    const Placeholder = (): JSX.Element => <></>;
    const PlaceholderWithLoading = WithLoading(Placeholder);

    useEffect(() => {
        if (loading) return;
        if (session?.authenticated) return;
        auth.login();
    }, [loading, session]);

    if (session?.authenticated) return <Redirect to="/" />;

    return <PlaceholderWithLoading loading={true} error={false} />;
};

export default SSORoute;
